import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import ProjectForm from "./ProjectForm";
import {getProject, updateProject} from "../../actions/projects";

const ProjectEdit = props => {
  const { project, codes, onSubmit, onCancel } = props;
  return <Card title='Project Details' className={'edit-view'}>
    <ProjectForm project={project} codes={codes} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let project = state.view.data[props.match.params.id];
      if (!project) return { loading: true };
      return { project: project.resource };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getProject(props.match.params.id)),
      onSubmit: (project) => {
        dispatch(updateProject(project));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(ProjectEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectEdit.js